// タブとコンテンツの要素を取得する
const tabBtns = document.querySelectorAll('.productDetail__info__tab__tablinks');
const tabContents = document.querySelectorAll('.productDetail__info__tab__content');

// タブとコンテンツをアクティブ化する関数
const activateTabs = tabIndexArray => {
  tabBtns.forEach((btn, index) => {
    // タブのアクティブ状態を切り替える
    const isActiveTab = tabIndexArray.includes(index);
    btn.classList.toggle('actived', isActiveTab);
    // コンテンツのアクティブ状態を切り替える
    tabContents[index].classList.toggle('actived', isActiveTab);
  });
};

// タブがクリックされたときの処理
tabBtns.forEach((btn, index) => {
  btn.addEventListener('click', () => {
    // PCとSPで同じDOMが存在するため、アクティブ化するタブとコンテンツのインデックスを決定する
    const activeTabIndexArray = index === 0 || index === 2 ? [0, 2] : [1, 3];
    // タブとコンテンツをアクティブ化する
    activateTabs(activeTabIndexArray);
  });
});

const sizeTabBtns = document.querySelectorAll('.productDetail__info__size__item');
const sizeTabContents = document.querySelectorAll('.productDetail__size__tab__content');

const activateSizeTabs = tabIndexArray => {
  sizeTabBtns.forEach((btn, index) => {
    const isActiveTab = tabIndexArray.includes(index);
    btn.classList.toggle('actived', isActiveTab);
    sizeTabContents[index].classList.toggle('actived', isActiveTab);
  });
};

sizeTabBtns.forEach((btn, index) => {
  btn.addEventListener('click', () => {
    const targetIndex = index + sizeTabBtns.length / 2;
    if (targetIndex < sizeTabBtns.length) {
      console.log('pc');
      activateSizeTabs([index, targetIndex]);
    } else {
      console.log('sp');
      activateSizeTabs([targetIndex - sizeTabBtns.length, index]);
    }
  });
});

// 初期状態として最初のタブをアクティブにする
activateTabs([0, 2]);
activateSizeTabs([0, sizeTabBtns.length / 2]);
